import React, { Component } from 'react'

import ImportMappingTableRows from './ImportMappingTableRows'
import ImportInstructions from 'components/Imports/ImportInstructions'

import './style.css'

const ImportMappingTableHeader = () => (
  <thead>
    <tr>
      <td>CSV COLUMN</td>
      <td>SAMPLE INFORMATION</td>
      <td>DRIFT ATTRIBUTE</td>
    </tr>
  </thead>
)

class ContactImportMappings extends Component {

  render() {
    const { upload, onChange } = this.props
    
    if(!upload) return null

    return (
      <div className="contact-import-mappings">
        <ImportInstructions />
        <div className="contact-import-mappings-table-container">
          <table className="drift-table">
            <ImportMappingTableHeader />
            <ImportMappingTableRows upload={upload} onChange={onChange} />
          </table>
        </div>
      </div>
    )
  }
}

export default ContactImportMappings